import SumInsuredIcon from "../assets/svgs/inclusion_sum_insured.svg";
import RoomLimitIcon from "../assets/svgs/inclusion_room_limit.svg";
import MaternityIcon from "../assets/svgs/inclusion_maternity.svg";
import BabyCoverageIcon from "../assets/svgs/inclusion_baby_coverage.svg";
import WaitingPeriodIcon from "../assets/svgs/inclusion_waiting_period.svg";
import CoPayIcon from "../assets/svgs/inclusion_co_pay.svg";
import OpdIcon from "../assets/svgs/inclusion_opd.svg";
import AmbulanceIcon from "../assets/svgs/inclusion_ambulance.svg";

export const FLEX_HEADERS = ["Mandatory", "Voluntary"];

export const INCLUSIONS = {
  sum_insured: {
    name: "Sum Insured",
    icon: SumInsuredIcon,
  },
  room_limit: {
    name: "Room Limit",
    icon: RoomLimitIcon,
  },
  maternity_coverage: {
    name: "Maternity",
    icon: MaternityIcon,
  },
  baby_coverage: {
    name: "Baby Coverage",
    icon: BabyCoverageIcon,
  },
  disease_wise_limit: {
    name: "Disease-wise Limit",
    icon: SumInsuredIcon,
  },
  co_pay: {
    name: "Co-Pay",
    icon: CoPayIcon,
  },
  waiting_period: {
    name: "Waiting Period",
    icon: WaitingPeriodIcon,
  },
  opd: {
    name: "OPD",
    icon: OpdIcon,
  },
  ambulance_limit: {
    name: "Ambulance Limit",
    icon: AmbulanceIcon,
  },
};

export const PRODUCTS_NAME = {
  "gmc_non_maternity": "Group Health Insurance",
  "gmc_maternity": "Group Health Insurance",
  "health_insurance": "Group Health Insurance",
  "group_personal_accidental": "Group Personal Accident",
  "personal_accident": "Group Personal Accident",
  "group_term_life": "Group Term Life",
  "term_life": "Group Term Life",
  "opd_cover": "OPD Cover",
  "critical_illness": "Critical Illness",
  "health_checkup": "Health Checkup",
  'mandatory_top_up_health': "Mandatory Top Up Health",
  'top_up_health': "Top Up Health",
  'parental_cover': "Parental Cover"
};

export const RELATIONS = {
  SELF: "Self",
  FATHER: "Father",
  MOTHER: "Mother",
  FATHERINLAW: "Father-in-law",
  MOTHERINLAW: "Mother-in-law",
  SPOUSE: "Spouse",
  DAUGHTER : "Daughter",
  SON: "Son",
  SIBLING: "Sibling"
}